/* eslint-disable react/no-unknown-property */
import React, { FC } from 'react';

import { Typography, Rating, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import RichTextComponentGraphQL from '../../RichTextComponentGraphQL';
import SectionWrapper from '../../SectionWrapper';
import { TMessagingBlade } from '../../../models/Message/@types';
import Typo from '../../Typo';
import styles from './gotSubmissions.module.sass';
import SkillBuilder from '../../../models/SkillBuilder';

export interface GotSubmission extends TMessagingBlade {
  skillbuilderId: string;
  userId: string;
}

const GotSubmission: FC<GotSubmission> = props => {
  const [value, setValue] = React.useState<number | null>(3);
  const [comment, setComment] = React.useState<string | null>('');
  const [thanksBool, setThanksBool] = React.useState<boolean>(false);

  const { heading, subHeading, commonProperties, description, skillbuilderId } = props;

  const parentBg = commonProperties?.backgroundColor ?? commonProperties?.parentBackgroundColor;

  return (
    <SectionWrapper
      hasBodyMargin={false} // :'(
      parentBackgroundColor={parentBg}
      // backgroundImage={commonProperties?.backgroundImage}
      classes={`${styles.body} has-text-centered is-color-White`}
    >
      <div className={styles.submissionHeader}>
        {heading && (
          <Typo h3 classes="mb-4 is-color-HighLightLime">
            {heading}
          </Typo>
        )}
        {description && (
          <Typo normal classes="mb-4">
            <RichTextComponentGraphQL json={description.json} links={description.links} />
          </Typo>
        )}
        {subHeading && <Typo small>{subHeading}</Typo>}
      </div>
      {thanksBool ? (
        <div className={styles.submissionResponse}>
          <i className={`las la-check-circle ${styles.submissionResponseIcon}`} />
          Thank You!
        </div>
      ) : (
        <div className={styles.submissionForm}>
          <Typography component="legend">Rate this Skillbuilder</Typography>
          <Rating
            name="simple-controlled"
            size={'large'}
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
          />
          <div>
            <TextField
              className={styles.submissionTextForm}
              id="outlined-multiline-static"
              label="Comments"
              multiline
              rows={4}
              defaultValue=""
              value={comment}
              onChange={event => {
                setComment(event.currentTarget.value);
              }}
            />
          </div>
          <div>
            <Button
              className={styles.submissionButton}
              onClick={async () => {
                await SkillBuilder.submitSkillBuilderFeedback(skillbuilderId, value, comment);
                setThanksBool(true);
              }}
            >
              submit
            </Button>
          </div>
        </div>
      )}
    </SectionWrapper>
  );
};

export default GotSubmission;
